const breeds = {
	state: {
		selectedBreeds: []
	},
	mutations: {
		setSelectedBreeds(state, breed) {
			const isIncluded = state.selectedBreeds.find(sb => sb.id === breed.id);
			if (!isIncluded) {
				state.selectedBreeds.push(breed);
			}
		},
		removeSelectedBreeds(state, breedId) {
			const index = state.selectedBreeds.findIndex(sb => sb.id === breedId);
			state.selectedBreeds.splice(index, 1);
		},
		clearSelectedBreeds(state) {
			state.selectedBreeds = [];
		}
	},
	getters: {
		getSelectedBreeds(state) {
			return state.selectedBreeds;
		}
	}
}

export default breeds;